module.exports = __webpack_public_path__ + "img/12.716e8262.png";